module.exports = __webpack_public_path__ + "img/design-image.daaa3c2d.jpg";